import { Component, OnInit } from '@angular/core';
import { ShopService } from '../shop.service';
import { Title }     from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  public products;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private shop:ShopService, private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("Shop -- Bender Hardware");
    if (isPlatformBrowser(this.platformId)) {
      this.shop.getProducts().then((products)=>{
        this.products = products;
      }).catch(err=>{
        this.products = [];
        console.error(err);
      });
    } else {
      this.shop.getProductsServerside().subscribe((products)=>{
        this.products = products;
      });
    }
    
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/products/products.component.ts